"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _TextInput = _interopRequireDefault(require("../molecules/TextInput"));

var _Checkbox = _interopRequireDefault(require("../molecules/Checkbox"));

var _Textarea = _interopRequireDefault(require("../molecules/Textarea"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = {
  'text': _TextInput["default"],
  'email': _TextInput["default"],
  'number': _TextInput["default"],
  'phone': _TextInput["default"],
  'url': _TextInput["default"],
  'checkbox': _Checkbox["default"],
  'textarea': _Textarea["default"]
};
exports["default"] = _default;